import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FiltroDocs } from 'src/app/shared/models/filtros';
import { DatosDocumentosService } from '../../services/datos-documentos.service';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { Router } from '@angular/router';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { TipoFiltro } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/tipo-filtro';

@Component({
  selector: 'app-documentos-filtros-nuevos',
  templateUrl: './documentos-filtros-nuevos.component.html',
  styleUrls: ['./documentos-filtros-nuevos.component.css']
})
export class DocumentosFiltrosNuevosComponent {

  tipoDocs: DesplegableData[] = [];
  tipoDocSeleccionado: DesplegableData;
  @Output() filtrarDocumentos: EventEmitter<FiltroSqp> = new EventEmitter<FiltroSqp>();

  constructor(private datosDocumentosService: DatosDocumentosService,
              private cdr: ChangeDetectorRef) {
                this.getTipoDocumentosLista();
              }

  ngOnInit(): void {
    this.seleccionarValorInicial();
  }

  getTipoDocumentosLista(){
    this.tipoDocs  = this.datosDocumentosService.GetTipoDocumentosLista();
  }

  private seleccionarValorInicial(): void {
    if(this.datosDocumentosService.filtros.length > 0){
      const filtroTipoDoc = this.datosDocumentosService.filtros.find(x => x.text === 'Tipo documento');
      if(filtroTipoDoc){
        if(filtroTipoDoc.tipoDoc === 'TODOS'){
          this.tipoDocSeleccionado = this.tipoDocs.find(tipo => tipo.desc === 'Todos los tipos documento') || this.tipoDocs[0];
        } else {
          this.tipoDocSeleccionado = this.tipoDocs.find(tipo => tipo.desc === filtroTipoDoc.tipoDoc) || this.tipoDocs[0];
        }
      } else {
        this.tipoDocSeleccionado = this.tipoDocs[0];
      }
    } else {
      this.tipoDocSeleccionado = this.tipoDocs[0];
    }
    this.cdr.detectChanges();
  }


  actualizaFiltroTipoDocumento(tipoDocSeleccionado: any){
    this.tipoDocSeleccionado = tipoDocSeleccionado;
    let tipo;
    if(this.tipoDocSeleccionado.desc === 'Todos los tipos documento'){
      tipo = {id:'TODOS', desc:'TODOS'}
    } else {
      tipo = this.tipoDocSeleccionado;
    }

    const filtroDocSqp: FiltroSqp = {
      titulo: 'Tipo documento',
      tipoFiltro: TipoFiltro.DESPLEGABLE,
      valoresSeleccionados: {
        valorString: tipo?.desc??''
      }
    }

    const filtroTipoDoc: FiltroDocs = {
      text: 'Tipo documento',
      textoBuscar: '',
      value: tipo?.desc??'',
      estado: '',
      idTipoDocumento: 0,
      nombre: '',
      tipoDoc: tipo?.desc??''
    }

    // let existeTipo = this.datosDocumentosService.filtros.findIndex(x=>x.text=='Tipo documento')
    // if(existeTipo>-1) this.datosDocumentosService.filtros[existeTipo] = filtroTipoDoc;
    // else this.datosDocumentosService.filtros.push(filtroTipoDoc)

    // this.datosDocumentosService.SetFilter(this.datosDocumentosService.filtros);
    // this.datosDocumentosService.Filter();

    // this.filtrarDocumentos.emit('Filtrar');
    this.filtrarDocumentos.emit(filtroDocSqp);


  }

}
